import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Resume from './pages/Resume';
import Contact from './pages/Contact';
import { navLinks } from './data';
import './App.css';

const App = () => {
  const appStyles = {
    minHeight: '100vh',
    background: 'radial-gradient(circle at top, rgba(0, 101, 105, 0.5), transparent 55%), #050a09ff',
    color: 'white',
    position: 'relative',
    overflow: 'hidden'
  };

  const glow = {
    position: 'fixed',
    width: '28rem',
    height: '28rem',
    borderRadius: '50%',
    filter: 'blur(100px)',
    opacity: 0.5,
    pointerEvents: 'none',
    zIndex: 0
  };

  return (
    <BrowserRouter>
      <div style={appStyles} >
        <div style={{ ...glow, top: '-10rem', left: '-8rem', background: 'rgba(0, 101, 105, 0.5)' }} />
        <div style={{ ...glow, bottom: '-12rem', right: '-6rem', background: 'rgba(0, 101, 105, 0.5)' }} />

        <Routes>
          <Route path="/" element={<Layout navLinks={navLinks} />}>
            <Route index element={<Home />} />
            <Route path="projects" element={<Projects />} />
            <Route path="resume" element={<Resume />} />
            <Route path="contact" element={<Contact />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default App;